// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__sOgiP","tabList":"Tabs_tabList__uOj07","tabButton":"Tabs_tabButton__RsOjb","activeTab":"Tabs_activeTab__VcH6u","tabPanel":"Tabs_tabPanel__fXk3d"};